/**
 * Resgata um filho reprovado pelo filtro a partir dos irmãos que passaram.
 * Usado por linhas sintéticas (subtotais) que precisam acompanhar o grupo em
 * vez de serem avaliadas pelo filtro do usuário.
 */
export type KeepChildOnFilter = (child: any, visibleSiblings: any[]) => boolean

/**
 * Filhos aprovados pelo filtro, mais os que `keepChildOnFilter` resgata a
 * partir deles, na ordem original.
 */
export function getVisibleChildren<T>(
    children: T[],
    filter: (row: T) => boolean,
    keepChildOnFilter?: KeepChildOnFilter,
): T[] {
    const visibleSiblings = children.filter(filter)
    if (!keepChildOnFilter) return visibleSiblings

    return children.filter(
        child =>
            visibleSiblings.includes(child) ||
            keepChildOnFilter(child, visibleSiblings),
    )
}
